/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'eye': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M256 156.443a98.61 98.61 0 00-27.77 4.445 49.256 49.256 0 016.436 24c0 27.308-22.47 49.778-49.778 49.778a49.256 49.256 0 01-24-6.435A99.295 99.295 0 00157 255.74c0 54.475 44.825 99.3 99.299 99.3 54.473 0 99.298-44.825 99.298-99.3 0-54.473-44.825-99.299-99.298-99.299l-.3.001zm252.91 86.58C460.705 148.967 365.272 85.33 256 85.33c-109.272 0-204.731 63.681-252.91 157.7a28.774 28.774 0 000 25.947c48.205 94.054 143.638 157.69 252.91 157.69 109.272 0 204.731-63.68 252.91-157.699a28.774 28.774 0 000-25.947zM256 384c-87.69 0-168.082-48.889-211.496-128.001C87.918 176.888 168.301 127.999 256 127.999c87.699 0 168.082 48.889 211.496 128.001C424.09 335.112 343.699 384.001 256 384.001z" fill-rule="nonzero"/>'
  }
})
